export default function initResetFilters() {
  document.querySelectorAll('input#action_doDocumentClearType').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      this.closest('form')
        .querySelectorAll('input[type=checkbox]')
        .forEach(checkbox => checkbox.checked = false);
    });
  });
}
